export default __webpack_public_path__ + "static/media/1.58961ea2.jpg";